import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=49811510&scoped=true&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49811510",
  null
  
)

export default component.exports